enum Apps {
  PicoX707 = 'picox707',
  Lighthouse710 = 'lighthouse710',
  SCMP711 = 'scmp711',
  Xtra = 'xtra',
  Paloalto623 = 'paloalto623',
  PolyU618 = 'polyu618',
  HKSTP608 = 'hkstp608',
  Ms624 = 'ms624'
}

export default Apps;
